import {Component, Input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslocoService} from '@ngneat/transloco';
import {AbstractComponent, LiveResultHeadingType} from "@components";
import {
  EventItem,
  Race,
  LiveResult,
  Lookups,
  Country,
  DEFAULT_PAGE_INDEX, PagedFilter, Pages, PAGE_SIZE_7, CompetitorLiveResults, Gender
} from "@model";
import {LiveControlService} from "@services";
import {debounceTime, distinctUntilChanged} from "rxjs";
import {environment} from "@environment";
import {LiveResultFilter} from "../../../model/live-result-filter";
import {LIVE_RESULTS} from "../../../app-routing.module";
import {LocalizedDatePipe} from "@pipes";

@Component({
  selector: 'app-live-results-race-details',
  templateUrl: './live-results-race-details.component.html',
  styleUrls: ['./live-results-race-details.component.scss'],
})
export class LiveResultsRaceDetailsComponent extends AbstractComponent {
  @Input() race: Race | undefined = undefined;
  @Input() event: EventItem | undefined = undefined;
  @Input() isFullScreen: boolean = false;
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];
  @Input({required: true}) genders: Country[] = [];
  @Input() liveResult: LiveResult | undefined = undefined

  protected competitorLiveResults: CompetitorLiveResults[] = [];

  image: string = `${environment.assetsImagesPath}/assets/img/carousel/live_results.png`;

  name: string = "";
  gender: number | undefined = undefined;
  overall: string | undefined = undefined;
  distance: number | undefined = undefined;
  queryParamsFirstChange: boolean = true;

  localizedDatePipe: LocalizedDatePipe;
  fullScreenMode: FullScreenMode = FullScreenMode.FULL
  leading: CompetitorLiveResults[] = [];


  constructor(private liveService: LiveControlService, private route: ActivatedRoute, private router: Router, public translocoService: TranslocoService) {
    super();
    this.localizedDatePipe = new LocalizedDatePipe(translocoService);
  }

  ngOnInit(): void {
    if (!this.isFullScreen) {
      this.subscribeToRouteDataChange();
    }
    this.subscriptions.push(this.liveService.liveResults.subscribe(val => {
      this.handleExploreResult(val)
    }))
    this.liveService.startFetchingResults(this.race, this.createFilter());
    this.handleExploreResult(this.liveResult);
  }


  subscribeToRouteDataChange() {
    this.subscriptions.push(this.route.queryParams.pipe(debounceTime(environment.fullTextSearchDelay),
        distinctUntilChanged()).subscribe((queryParams: any) => {
        this.name = queryParams.name ? queryParams.name : "";
        this.gender = queryParams.gender ? +queryParams.gender : undefined;
        if (!this.queryParamsFirstChange && this.isGenderValid(queryParams.gender)) {
          this.liveService.startFetchingResults(this.race, this.createFilter());
        }
        this.queryParamsFirstChange = false;
      })
    );
  }

  handleExploreResult(liveResult: LiveResult | null | undefined): void {
    if (!liveResult) {
      this.competitorLiveResults = [];
      this.leading = [];
    }

    if (liveResult?.leading) {
      this.leading = [...liveResult.leading]
    } else {
      this.leading = [];
    }

    if (liveResult?.results) {
      this.competitorLiveResults = liveResult.results;

    } else {
      this.competitorLiveResults = [];
    }
  }


  private isGenderValid(gender: number | undefined) {
    if (!gender) return true;
    else {
      return this.genders.filter((g: Lookups) => g.id === +gender).length > 0;
    }
  }

  exportToPDF() {
    //todo
  }

  handleInput(value: string) {
    this.name = value.trim() ?? "";
    this.changeQueryParams();
  }

  handleGenderSelection(value?: number): void {
    if (value === this.gender || !value) {
      this.gender = undefined;
    } else {
      this.gender = value;
    }
    this.changeQueryParams()
  }


  createFilter() {
    return new PagedFilter<LiveResultFilter>(new Pages(PAGE_SIZE_7, DEFAULT_PAGE_INDEX), new LiveResultFilter(
      this.race?.id, undefined, this.name !== "" ? this.name : undefined, this.gender, undefined
    ))
  }

  private changeQueryParams(): void {
    let queryParams: { [key: string]: any } = {};
    queryParams["eventId"] = this.event?.id;
    queryParams["raceId"] = this.race?.id
    if (this.gender) {
      queryParams['gender'] = this.gender;
    }
    if (this.name && this.name.length > 0) {
      queryParams['name'] = this.name
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      replaceUrl: true
    });
  }

  logoClicked() {
    this.router.navigate([LIVE_RESULTS]);
  };


  toggleView() {
    if (this.fullScreenMode === FullScreenMode.SPLIT) {
      this.fullScreenMode = FullScreenMode.FULL
    } else {
      this.fullScreenMode = FullScreenMode.SPLIT;
    }
  }

  protected readonly LiveResultHeadingType = LiveResultHeadingType;
  protected readonly FullScreenMode = FullScreenMode;
  protected readonly Gender = Gender;

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.liveService.clearAll();
  }
}

export enum FullScreenMode {
  SPLIT,
  FULL
}
